<template>
    <!-- 兵道 -->
  <div class="box-css">
    <div class="type-css">
      <div>
        <span style="font-size:16px;">
          <b>获胜方式统计</b>&ensp;&ensp;|&ensp;&ensp;
          共计胜场{{ detail.winNum }}场次
        </span>
      </div>
      <div id="main" style="height: 350px;"></div>
      <div class="type-font-box">
        <div v-for="(item,index) in colorList" :key="index">
            <span class="square" :style="{backgroundColor:item.color}"></span>
            <span class="txt">{{item.name}}</span>
            <span class="num">{{data.winType[item.code]}}</span>
        </div>
      </div>
    </div>
    <div class="radar-css">
      <div>
        <span class="radar-span">
          <b>攻防对比</b>（近10场）
        </span>
      </div>
      <div id="main2" style="height: 300px;"></div>
      <span class="badge-a">
        <a-badge status="error" :text="attackDefense.defense.oneScore + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.oneScore + ''" />
      </span>
      <span class="badge-b">
        <a-badge status="error" :text="attackDefense.defense.seriousWarning + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.seriousWarning + ''" />
      </span>
      <span class="badge-c">
        <a-badge status="error" :text="attackDefense.defense.threeScore + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.threeScore + ''" />
      </span>
      <span class="badge-d">
        <a-badge status="error" :text="attackDefense.defense.twoScore + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.twoScore + ''" />
      </span>
      <span class="badge-e">
        <a-badge status="error" :text="attackDefense.defense.warning + ''" color="#2db7f5"/><br />
        <a-badge status="error" :text="attackDefense.attack.warning + ''" />
      </span>
    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts'
import matchFun from '@comm/utils/matchFun.js'
export default {
  data () {
    return {
      programId: this.$route.query.programId,
      rank: this.$route.query.rank,
      matchFun,
      detail: {},
      colorList: [
        {color:'#04b4e5',name:'DSQ 失格胜', code: 'dsq'},
        {color:'#049b18',name:'GDP 以加时赛先得分获胜', code: 'gdp'},
        {color:'#224f8a',name:'KO 击倒胜', code: 'ko'},
        {color:'#006dd6',name:'PTF 比分胜', code: 'ptf'}, 
        {color:'#72c707',name:'PTG 分差优势胜', code: 'ptg'}, 
        {color:'#ffcf01',name:'PUN 犯规胜', code: 'pun'}, 
        {color:'#ff8a00',name:'RSC 终止比赛胜', code: 'rsc'}, 
        {color:'#ff7200',name:'SIP 小局获胜', code: 'sip'},
        {color:'#ff4f01',name:'WDR 失格胜', code: 'wdr'},
        {color:'#049b10',name:'WIW 比分胜', code: 'win'}, 
      ],
      data: {
        winType: {
          expressive: 0,
          accuracy: 0,
          details: []
        },
       
      },
      attackDefense: {
        defense: {
          oneScore: 0,
          seriousWarning: 0,
          threeScore: 0,
          twoScore: 0,
          warning: 0
        },
        attack: {
          oneScore: 0,
          seriousWarning: 0,
          threeScore: 0,
          twoScore: 0,
          warning: 0
        }
      }
    }
  },
  created () {
    this.detail = JSON.parse(decodeURI(this.$route.query.detail))
    this.findData()
  },
  methods: {
    findData () {
      this.$api.match.playerTechnical({cardId: this.detail.cardId, programId: this.programId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.attackDefense = res.data.attackDefense
          this.drawData(res.data.winType)
          this.radarData(res.data.attackDefense)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    drawData (data) {
      let arr = []
      for (let key in data) {
        arr.push({
          value: data[key],
          name: key.toUpperCase() + '：' + data[key]
        })
      }
      var chartDom = document.getElementById('main')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#04b4e5', '#049b18', '#224f8a', '#006dd6', '#72c707', '#ffcf01', '#ff8a00', '#ff7200', '#ff4f01'],
        series: [
          {
            name: '数据',
            type: 'pie',
            radius: ['50%', '70%'],
            center:['75%','50%'],
            label: {
              show: false,
              position: 'right'
            },
            left: 0,
            top: 0,
            data: arr
          }
        ]
      }

      option && myChart.setOption(option)
    },
    radarData (data) {
      var chartDom = document.getElementById('main2')
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'axis'
        },
        color: ['#04b4e5', '#ff4f01'],
        legend: {
          left: 'center',
          data: [
            '得分数据',
            '失分数据'
          ]
        },
        radar: [
          {},
          {
            indicator: [
              { text: '拳' },
              { text: '击头能力' },
              { text: '躯干击打' },
              { text: '旋转躯干' },
              { text: '警告' }
            ],
            radius: 110,
            center: ['50%', '60%']
          }
        ],
        series: [
          {
            type: 'radar',
            radarIndex: 1,
            areaStyle: {},
            data: [
              {
                value: [data.defense.punchCount, data.defense.headCount, data.defense.bodyCount, data.defense.backCount, data.defense.warnCount],
                name: '得分数据'
              },
              {
                value: [data.attack.punchCount, data.attack.headCount, data.attack.bodyCount, data.attack.backCount, data.attack.warnCount],
                name: '失分数据'
              }
            ]
          }
        ]
      }

      option && myChart.setOption(option)
    }
  }
}
</script>
<style lang="scss" scoped>
.box-css{
  width: 1200px;
  margin: 20px auto;
  overflow: hidden;
}
.type-css{
  width: 600px;
  float: left;
  height: 360px;
  border-right: 1px solid rgb(231, 231, 231);
  position: relative;
}
.radar-css{
  width: 600px;
  float: left;
  height: 320px;
  position: relative;
}
.poomsae-css{
  width: 1200px;
  float: left;
  height: 390px;
  position: relative;
  border-top: 5px solid rgb(238, 236, 236);
  border-bottom: 5px solid rgb(238, 236, 236);
  margin-top: 30px;
}
.time-list{
  width:600px;max-height: 300px;overflow-y: auto;float:left;
}
.time-item{
  width:100%;height:45px;line-height:45px;background:rgb(241, 241, 241);
}
.time-item-li{
  width:25%;height:45px;float:left;text-align: center;
}
.power-css{
  width: 1200px;
  float: left;
  height: 410px;
  position: relative;
  overflow: hidden;
  margin-top: 20px;
}
.time-line{
  position: absolute;top: 23px;left: 17px;z-index: 99;color:white;
}
.type-font-box{
  position: absolute;left: 0px;top: 40px;line-height:22px;color:gray;
}
.radar-span{
  font-size:16px;margin-left:20px;
}
.badge-a{
  position: absolute;top: 55px;left: 320px;line-height:15px;
}
.badge-b{
  position: absolute;top: 180px;left: 420px;line-height:15px;
}
.badge-c{
  position: absolute;top: 290px;left: 430px;line-height:15px;
}
.badge-d{
  position: absolute;top: 290px;left: 140px;line-height:15px;
}
.badge-e{
  position: absolute;top: 180px;left: 135px;line-height:15px;
}
.square{
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    margin-right: 10px;
}
.txt{
    display: inline-block;
    width: 160px;
    line-height: 30px;
    text-align: left;
    // overflow: hidden;
    // white-space: normal;
    // text-overflow: ellipsis;
}
.num{
    display: inline-block;
    width: 70px;
    line-height: 30px;
    border: 1px solid #E8E8E8;
    font-weight: 600;
    box-sizing: border-box;
    font-size: 14px;
    text-align: right;
    padding-right: 20px;
    margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/module/SkillRuse.vue